// Common
import './lib/common/common.js';

// Load Web components
import '../components/kw-banner/kw-banner.js';
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-title/kw-title.js';
import '../components/kw-wrapper-events/kw-wrapper-events.js';

// Load scroll behavior to show/hide header
import './lib/scroll/scroll.js';

import data from '../json/events.json.js';
import { CommonTpl } from './pages/common.html.mjs';
import dataBanner from './lib/dataBanner.js';

CommonTpl.setData(data);
CommonTpl.detectLanguage();
// eslint-disable-next-line no-console
console.info(`LANG: ${CommonTpl.LANG}`);

let dataStrapi;
const envProd = window.location.host === 'kairosds.com' || window.location.host === 'www.kairosds.com';
const params = envProd ? '?_limit=-1' : '?status=draft&status=published&_limit=-1';

function banner() {
  const bannerData = document.getElementById('banner-events');
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="medium" animation-type="slide-toleft" change-interval="8">
            ${CommonTpl.dataLanguage(data.banners).map(dataBanner.banner).join('')}
          </kw-banner>
    `;
}

function drawEvent(event) {
  const baseUrl = 'https://strapi-beta.kairosds.com';
  return `
    <div>
      <div id="imgMedium">${event.imageMedium ? `${baseUrl}${event.imageMedium.url}` : ''}</div>
      <div id="imgLarge">${event.imageLarge ? `${baseUrl}${event.imageLarge.url}` : ''}</div>
      <div id="title">${event.title ? CommonTpl.cookData(event.title) : ''}</div>
      <div id="subtitle">${event.subtitle ? event.subtitle : ''}</div>
      <div id="description">${event.description ? CommonTpl.cookData(event.description) : ''}</div>
      <div id="startDate">${event.startDate ? event.startDate : ''}</div>
      <div id="lengthEvent">${event.lengthEvent ? event.lengthEvent : ''}</div>
      <div id="position">${event.position ? event.position : ''}</div>
      <div id="speaker">${event.speaker ? event.speaker : ''}</div>
      <div id="type">${event.type ? event.type : ''}</div>
      <div id="capacity">${event.capacity ? event.capacity : ''}</div>
      <div id="importantEvent">${event.importantEvent ? event.importantEvent : ''}</div>
      <div id="comingEvent">${event.comingEvent ? event.comingEvent : ''}</div>
      <div id="urlLink">${event.urlLink ? event.urlLink : ''}</div>
      <div id="textLink">${event.textLink ? event.textLink : ''}</div>
      <div id="ariaLabel">${event.ariaLabel ? event.ariaLabel : ''}</div>
    </div>
  `;
}

function drawEvents(eventsList) {
  const arrEvents = [];
  eventsList.forEach((ev) => {
    arrEvents.push(drawEvent(ev));
  });
  const eventslayer = /* html */ `${arrEvents.join('')}`;
  return eventslayer;
}

function renderEvents() {
  const eventsContainer = document.querySelector('#container__events');
  eventsContainer.innerHTML = `
  <div class="col-lg-12 container__events--box">
    <kw-wrapper-events language = ${CommonTpl.languageDefault(data.eventsListData.eventsListsData)} >
      <div id="titles">
        <h3>${CommonTpl.dataLanguage(data.eventsData.eventsData).importantEventsTitle}</h3>
        <h3>${CommonTpl.dataLanguage(data.eventsData.eventsData).comingEventsTitle}</h3>
      </div>
      <div id="events" >
        ${drawEvents(dataStrapi)};
      </div> 
    </kw-wrapper-events>
  </div>
  `;
}

function init() {
  fetch(`https://strapi-beta.kairosds.com/events-lists${params}`)
    .then((response) => response.json())
    .then((dataEvents) => {
      dataStrapi = dataEvents;
      renderEvents();
    });
}

// eslint-disable-next-line func-names
window.onload = function () {
  banner();
  init();
};
